import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import WelcomeSpreadFooter from './WelcomeSpreadFooter';

interface WelcomeSpreadLayoutProps {
  children: React.ReactNode;
}

const WelcomeSpreadLayout: React.FC<WelcomeSpreadLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#F5F3F0',
      }}
    >
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginTop: '64px', // Header height
          marginBottom: '60px', // Footer height
        }}
      >
        {children}
      </Box>
      <WelcomeSpreadFooter />
    </Box>
  );
};

export default WelcomeSpreadLayout;
